import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import MainFeature from "components/features/TwoColWithButton.js";
import Footer from "components/footers/MiniCenteredFooter";
import servicio1 from 'assets/images/servicio1.jpg';
import servicio2 from 'assets/images/servicio2.jpg';

export default () => {
    const Subheading = tw.span`tracking-wider text-sm font-medium`;
    const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
    const Description = tw.span`inline-block mt-8`;
    const imageCss = tw`rounded-4xl`;
    return (
        <AnimationRevealPage disabled>
            <Hero roundedHeaderButton={true} />
            <MainFeature
                subheading={<Subheading></Subheading>}
                heading={
                    <>
                        Servicio de Agenciamiento
                        <br /> <HighlightedText></HighlightedText>
                    </>
                }
                description={
                    <Description>
                        LIP Aduanas S.A. brinda el servicio de Agenciamiento Aduanero para las operaciones de Importación y Exportación dentro de los mejores estándares de seguridad y calidad de servicio, con oficinas en las principales aduanas del país: Callao, Chiclayo, Paita, Pisco y Salaverry.
                        LIP Aduanas S.A. realiza despachos de aduanas para todos los regímenes, tanto en Exportaciones como Importaciones, para carga en general, restringida y peligrosa.
                        <br />
                        <br />
                    </Description>
                }
                buttonRounded={false}
                textOnLeft={false}
                primaryButtonText="Latest Offers"
                imageSrc={
                    servicio1
                }
                imageCss={imageCss}
                imageDecoratorBlob={true}
                imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
            />
            <MainFeature
                subheading={<Subheading></Subheading>}
                heading={
                    <>
                        Servicios Conexos
                        <br /> <HighlightedText></HighlightedText>
                    </>
                }
                description={
                    <Description>
                        De la mano con Lip Transportes y New Transport, Lip Aduanas S.A. brinda los servicios de logistica aduanera.
                        <br />
                        <br />
                    </Description>
                }
                buttonRounded={false}
                textOnLeft={true}
                primaryButtonText="Latest Offers"
                imageSrc={
                    servicio2
                }
                imageCss={imageCss}
                imageDecoratorBlob={true}
                imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
            />
            <Footer />
        </AnimationRevealPage>
    );
}
